exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.extrasHolder[data-v-b3869a5a] {\n  max-height: 370px;\n  overflow-y: auto;\n}\n.editReservationPopupBg[data-v-b3869a5a] {\n  background-color: rgba(0, 0, 0, 0.5);\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  z-index: 10;\n  position: absolute;\n  max-width: 100%;\n}\n.editReservationPopupBg .popupArea[data-v-b3869a5a] {\n    width: 1000px;\n    max-width: 100%;\n    max-height: 100%;\n    margin: 0 auto;\n    overflow: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-b3869a5a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/ReservationEditV2/EditExtras.vue
// module id = 2038
// module chunks = 0